import LocalStorage from 'utils/local-storage';
import { Keys as StorageKeys } from 'utils/local-storage/constants';

export const resetLastTimeStoreUpdated: (currentTime?: number) => void = currentTime =>
  LocalStorage.setItem(StorageKeys.LAST_TIME_STORE_UPDATED, currentTime || Date.now());
